import { Typography } from '@design-system/components/typography/typography';
import { FormDataMultiSelect } from '../viewModel/otpBundles.viewModel';
import { isEmpty } from 'lodash';
import { Link } from 'react-router';
import { DropDownMultiselect } from '@client/new/pages/bundles/otp/view/dropDownMultiselect/dropDownMultiselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sprinkles } from '@design-system/sprinkles.css';

export const ContentSection = ({
  sectionTitle,
  emptyState,
  items,
  selectedItems,
  disabled,
}: FormDataMultiSelect & { disabled: boolean }) => {
  if (isEmpty(items)) {
    return (
      <div className="flex flex-col gap-4">
        <Typography variant="body" size="large">
          {sectionTitle}
        </Typography>
        <div className="flex gap-1 items-center">
          <Typography
            variant="body"
            size="medium"
            color="N-80"
            className="underline cursor-pointer"
            onClick={emptyState.onClick}
          >
            {emptyState.urlLabel}
          </Typography>
          <Typography variant="body" size="medium" color="N-80">
            {emptyState.label}
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <Typography
        variant="body"
        size="large"
        color={disabled ? 'N-60' : 'B-100'}
      >
        {sectionTitle}
      </Typography>
      <DropDownMultiselect items={items} disabled={disabled} />
      <ContentList selectedItems={selectedItems} disabled={disabled} />
    </div>
  );
};

const ContentList = ({
  selectedItems,
  disabled,
}: Pick<FormDataMultiSelect, 'selectedItems'> & { disabled: boolean }) => (
  <div>
    {selectedItems.map((item) => (
      <div
        key={item.id}
        className="flex justify-between border-b-[1px] border-[#E2E2E2] py-2 gap-2"
      >
        <Typography
          color={disabled ? 'N-60' : 'B-100'}
          className="overflow-x-hidden"
        >
          {item.name}
        </Typography>
        {!disabled && (
          <div className="flex gap-4">
            {item.cta.map((cta, index) => (
              <FontAwesomeIcon
                key={index}
                icon={cta.icon}
                onClick={cta.onClick}
                className={sprinkles({
                  cursor: 'pointer',
                  color: cta?.color || 'B-100',
                })}
              />
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);
